import "./App.css";
import { useEffect, useState } from "react";
import Navbar from "./components/nav/Navbar";
import HomeSection from "./components/home/HomeSection";
import CompartirMascota from "./components/pets/CompartirMascota";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Perfil from "./components/profile/PerfilSection";
import SignInSide from "./components/profile/SignIn";
import EditarPerfil from "./components/profile/EditarPerfil";
import MascotasPublicadas from "./components/pets/MascotasPublicadas";
import Footer from "./components/footer/Footer";
import Buscador from "./components/pets/Buscador";
import PreguntasFrecuentes from "./components/PreguntasFrecuentes";
import QuienesSomos from "./components/QuienesSomos";
import PetDetails from "./components/pets/PetDetails";
import ScrollToTop from "./features/scrollToTop";

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  useEffect(() => {
    const loader = document.getElementById("home-loader");
    if (loader) loader.remove();
  }, []);

  return (
    <Router>
      <Navbar isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen}/>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomeSection isMenuOpen={isMenuOpen} />} />
        <Route path="/compartir" element={<CompartirMascota />} />

        <Route path="/editar/:id" element={<CompartirMascota />} />

        <Route path="/compartir" />

        <Route path="/buscador/encontrado" element={<Buscador state={"3"} />} />

        <Route
          path="/buscador/buscando/:lat?/:lng?"
          element={<Buscador state={"1"} />}
        />

        <Route path="/buscador/adopcion" element={<Buscador state={"4"} />} />

        <Route path="mascota/:id" element={<PetDetails />} />

        <Route path="/sign-in" element={<SignInSide />} />

        <Route path="/perfil" element={<Perfil />} />

        <Route path="/editar-perfil" element={<EditarPerfil />} />

        <Route path="/mascotas-publicadas" element={<MascotasPublicadas />} />
        <Route path="/preguntas-frecuentes" element={<PreguntasFrecuentes />} />
        <Route path="/quienes-somos" element={<QuienesSomos />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
